import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useSortedTags } from 'features/tags';
import React from 'react';
import { SettingsSort18 } from 'shared/assets/icons';
import { SmartListContextMenu } from 'shared/components/connected/smart-list-context-menu';
import { FilterButton } from 'shared/components/ui/filter-button';
import { IconButton } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FilterDocument } from 'shared/types/filter-document';
import { SmartList } from 'shared/types/smart-list';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';

const supportedGroupByModes: TaskGroupBy[] = [
  GroupByMode.None,
  GroupByMode.Goal,
  GroupByMode.LifeArea,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
];

type InteractionsProps = {
  smartList: SmartList;
  showCompleted: boolean;
  onToggleShowCompleted: () => void;
  onEdit: () => void;
  filterDocument: FilterDocument;
  defaultFilterDocument: FilterDocument;
  onUpdateFilterDocument: (filterDocument: FilterDocument) => void;
  onResetFilter: () => void;
  onUpdateSmartList: () => void;
};

export const Interactions: React.FC<InteractionsProps> = ({
  smartList,
  showCompleted,
  onToggleShowCompleted,
  onEdit,
  filterDocument,
  defaultFilterDocument,
  onUpdateFilterDocument,
  onResetFilter,
  onUpdateSmartList,
}) => {
  const filterButtonRef = React.useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const tags = useSortedTags();

  return (
    <>
      <FilterButton
        filterDocument={filterDocument}
        defaultFilterDocument={defaultFilterDocument}
        updateFilterDocument={onUpdateFilterDocument}
        onReset={onResetFilter}
        onUpdateSmartList={onUpdateSmartList}
        tags={tags}
        goals={goals}
        lifeAreas={lifeAreas}
        supportedGroupByModes={supportedGroupByModes}
        renderAsIconButton
        preventDrag
      />
      <IconButton
        icon={SettingsSort18}
        ref={filterButtonRef}
        onClick={openMenu}
        preventDrag
      />
      <SmartListContextMenu
        smartList={smartList}
        referenceElement={filterButtonRef}
        onClose={closeMenu}
        showCompleted={showCompleted}
        onToggleShowCompleted={onToggleShowCompleted}
        onEdit={onEdit}
        open={menuOpen}
      />
    </>
  );
};
